<script setup>
  import BudgetTotalCard from "./BudgetTotalCard.vue";
  import BudgetBidderCard from "./BudgetBidderCard.vue";
</script>

<template>
  <div class="flex flex-col gap-4">
    <BudgetTotalCard />
    <BudgetBidderCard />
  </div>
</template>
